import { Directive, forwardRef } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS } from '@angular/forms';

/**
 * Email validator - validates form control value has a valid email
 * - Undefined considered no content
 * - Null considered no content
 * - String that does not pass regular expression considered not content
 * @returns {(c:FormControl)=>any}
 */
function emailValidatorFactory() {
    return (c: UntypedFormControl) => {
        const noError: any = null;
        const error = {
            emailValidator: {
                email: {
                    invalid: true
                }
            }
        };

        const emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (c.value === undefined || c.value === null) {
            return error;
        } else if (!emailRegEx.test(c.value)) {
            return error;
        }

        return noError;
    };
}

/**
 * Required validator directive
 */
@Directive({
    selector: '[xlog-email-validator][ngModel],[xlog-email-validator][formControl]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => EmailValidatorDirective), multi: true }
    ],
    standalone: false
})
export class EmailValidatorDirective {
    validator: Function;

    constructor() {
        this.validator = emailValidatorFactory();
    }

    validate(c: UntypedFormControl) {
        return this.validator(c);
    }
}
